module.exports = __webpack_public_path__ + "static/media/people14.2ae405d7.jpeg";